import { httpService } from "common/services";
import { API_URL } from "config/constants";
import { Mode } from "models/Mode";
import { TimeRange } from "models/Reservation";
import { Table } from "models/Table";

export async function fetchTables(data: TimeRange): Promise<Array<Table> | undefined> {
    const res = await httpService.request({ data, method: "POST", url: `${ API_URL }tables` });
    return res.data as Array<Table>;
}

export async function getTablesTimeRanges(data: { excludedReservation?: string, mode: Mode, start: string, tableIds: Array<string> }): Promise<Array<TimeRange> | undefined> {
    const { mode, ...rest } = data;

    switch (mode) {
        case Mode.RESERVATION_BROWSING:
        case Mode.PRINTING:
        case Mode.REPORT:
        case Mode.RESERVATION_PREVIEW_FROM_SEARCH:
        case Mode.RESERVATION_PREVIEW:
        case Mode.SEARCHING:
            return;

        default:
            return (await httpService.request({ data: rest, method: "POST", url: `${ API_URL }tables-time-ranges` })).data as Array<TimeRange>;
    }
}